var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('h3',[_c('i18n',{attrs:{"path":"policies.label"}},[_c('a',{staticClass:"href",attrs:{"href":_vm.$t('policies.data.url'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('policies.data.label')))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }